(() => {
    const shadesWrap = document.querySelector('.item-color');
    const headingEls = document.querySelectorAll('.item-color__header .item-color__heading');
    const thumbEls = document.querySelectorAll('.item-color__thumbs .swiper-slide');
    const galleryEl = document.querySelector('.item-color__gallery');
    const thumbsEl = document.querySelector('.thumbs-swiper');
    const mainVideoElement = document.querySelector('.slider-after video');

    if (!galleryEl || !thumbsEl || !thumbEls.length || !headingEls.length) return;

    const gallerySwiper = new Swiper(galleryEl, {
        effect: 'fade',
        speed: 400,
        observer: true,
        observeParents: true,
        fadeEffect: { crossFade: true },
        navigation: {
            nextEl: shadesWrap.querySelector('.swiper-button-next'),
            prevEl: shadesWrap.querySelector('.swiper-button-prev')
        },
        on: {
            slideChange() {
                const index = this.realIndex;
                updateActiveState(index);
                
            },
        },
    });

    thumbsSwiper = new Swiper(thumbsEl, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        centeredSlides: false,
        loop: false,
        watchOverflow: false,
        observer: true,
        observeParents: true,
        resizeObserver: true,
        slideToClickedSlide: true,
        centerInsufficientSlides: true,
        freeMode: true
    });

    const updateActiveState = (index) => {
        headingEls.forEach((el, i) => {
            el.style.display = i === index ? 'block' : 'none';
        });

        thumbEls.forEach((el, i) => {
            el.classList.toggle('is-active', i === index);
        });

        // 활성화된 썸네일의 'data-target-src' 값을 가져와 비디오 소스를 업데이트합니다.
        const activeSlide = thumbEls[index];
        const newVideoSource = activeSlide?.dataset.targetSrc;

        if (newVideoSource) {
            // 메인 비디오 요소의 src를 변경하고 로드/재생합니다.
            mainVideoElement.src = newVideoSource;
            mainVideoElement.load();
            mainVideoElement.play();
        }
    };

    thumbEls.forEach((el, i) => {
        el.addEventListener('click', () => {
            updateActiveState(i);
            gallerySwiper.slideTo(i);
            thumbsSwiper.slideTo(i);
        });
    });

    updateActiveState(0);
})();

